import * as React from 'react';
const SvgLands = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 13a.75.75 0 01.75-.75h20a.75.75 0 110 1.5H2a.75.75 0 01-.75-.75z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.653 12.367a.75.75 0 01.23 1.036l-3.5 5.5a.75.75 0 11-1.266-.806l3.5-5.5a.75.75 0 011.036-.23zM18.347 12.367a.75.75 0 00-.23 1.036l3.5 5.5a.75.75 0 101.266-.806l-3.5-5.5a.75.75 0 00-1.036-.23zM8.943 12.275a.75.75 0 01.532.918l-2 7.5a.75.75 0 11-1.45-.386l2-7.5a.75.75 0 01.918-.532zM15.057 12.275a.75.75 0 00-.532.918l2 7.5a.75.75 0 101.45-.386l-2-7.5a.75.75 0 00-.918-.532zM12 12.25a.75.75 0 01.75.75v8.5a.75.75 0 01-1.5 0V13a.75.75 0 01.75-.75zM17 6.75a.75.75 0 01.75.75V13a.75.75 0 01-1.5 0V7.5a.75.75 0 01.75-.75z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.849 1.935a.234.234 0 00-.09.136L14.995 8.25h4.012L17.24 2.071a.235.235 0 00-.088-.136A.265.265 0 0017 1.89a.265.265 0 00-.151.045zm-1.532-.276c.484-1.692 2.882-1.692 3.366 0l1.892 6.625A1.15 1.15 0 0119.47 9.75h-4.94a1.15 1.15 0 01-1.105-1.466l1.892-6.625zM7.5 6.25a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0V7a.75.75 0 01.75-.75z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 2.75a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5zM3.25 5.5a4.25 4.25 0 118.5 0 4.25 4.25 0 01-8.5 0z"
        fill="currentColor"
      />
    </svg>
  );
};
const MemoSvgLands = React.memo(SvgLands);
export default MemoSvgLands;
